import {
  RiCheckboxCircleLine,
  RiCloseCircleLine,
} from '@/shared/icons/remix'
import {
  paletteErrorMain,
  paletteSuccessMain,
} from '../styles/resetPasswordStyles'

export function PasswordRuleStatusIcon({
  met,
  show,
}: {
  readonly met: boolean
  readonly show: boolean
}) {
  if (!show) {
    return null
  }
  if (met) {
    return (
      <RiCheckboxCircleLine
        size={16}
        color={paletteSuccessMain}
        aria-hidden
      />
    )
  }
  return (
    <RiCloseCircleLine size={16} color={paletteErrorMain} aria-hidden />
  )
}
